
/*
    mobile-setup is meant to handle running and adding app
    hooks to improve performance and ux on mobile.
*/
angular.module('PatientApp').run(function() {
    if(window.FastClick){
        window.FastClick.attach(document.body); 
    }
});